<template>
  <section class="main-visual" data-style="show">
    <div ref="visualSwiper" class="swiper">
      <div class="swiper-wrapper">
        <div
          v-for="(item, key) in visualList"
          :key="key"
          class="swiper-slide"
        >
          <a :href="item[locale].link" :target="item.target" class="main-visual-item">
            <div class="main-visual-content">
              <html-view :value="item[locale].title" tag="strong" />
              <html-view :value="item[locale].category" class="category" tag="span" />
            </div>

            <video
              v-if="item.video"
              id="video"
              muted
              loop
              playsinline
              preload
              autoplay
              poster="~@/static/image/service/font.jpg"
            >
              <source src="~@/static/video/service_font.mp4" type="video/mp4">
              Sorry, your browser doesn't support embedded videos.
            </video>
            <picture v-else>
              <source :srcset="item.pc" media="(min-width: 980px)">
              <source :srcset="item.m" media="(max-width: 980px)">
              <img :src="item.pc" :alt="`${item[locale].title}`">
            </picture>

          </a>
        </div>
      </div>
      <div class="swiper-navigation">
        <div ref="pagination" class="swiper-pagination" />
        <!--        <div ref="scrollbar" class="swiper-scrollbar" />-->
        <button ref="prev" type="button" class="swiper-button-prev">
          <arrow />
        </button>
        <button ref="next" type="button" class="swiper-button-next">
          <arrow />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper, { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper'
import gtag from '@/mixins/gtag'
import { mapGetters } from 'vuex'

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar])

export default {
  components: {
    arrow: () => import('@/static/svg/arrow-banner.svg'),
  },
  mixins: [gtag],
  data () {
    return {
      visualSlider: null,
      visualList: [
        {
          target: '_self',
          pc: require('@/static/image/main/pc/banner-1-1.jpg'),
          m: require('@/static/image/main/m/banner-1-1.jpg'),
          ko: {
            link: '/company/culture',
            title: '가장 앞서<br class="m"> 달립니다',
            category: 'about us',
          },
          en: {
            link: '/en/company/culture',
            title: 'We lead the way',
            category: 'about us'
          }
        },
        {
          target: '_self',
          pc: require('@/static/image/main/pc/banner-2-1.jpg'),
          m: require('@/static/image/main/m/banner-2-1.jpg'),
          ko: {
            link: '/service/commerce',
            title: '지금 찾는 것<br class="m"> 모두 여기',
            category: 'service'
          },
          en: {
            link: '/en/service/commerce',
            title: 'Everything you need',
            category: 'service'
          }
        },
        {
          target: '_self',
          pc: require('@/static/image/main/pc/banner-3@2x.jpg'),
          m: require('@/static/image/main/m/banner-3@2x.jpg'),
          ko: {
            link: '/service/order#배민로봇',
            title: '자율주행 배달로봇',
            category: 'robot'
          },
          en: {
            link: '/service/order#배민로봇',
            title: 'Self-driving delivery robot',
            category: 'robot'
          }
        },
        {
          target: '_blank',
          pc: require('@/static/image/main/pc/banner-4-1.jpg'),
          m: require('@/static/image/main/m/banner-4-1.jpg'),
          ko: {
            link: 'https://career.woowahan.com/',
            title: '지금은 채용 중',
            category: 'careers'
          },
          en: {
            link: 'https://career.woowahan.com/',
            title: 'Looking for talent',
            category: 'careers'
          }
        },
        {
          target: '_self',
          pc: require('@/static/image/main/pc/banner-5-1.jpg'),
          m: require('@/static/image/main/m/banner-5-1.jpg'),
          ko: {
            link: '/sustainability',
            title: '장사에 힘이 됩니다',
            category: 'sustainabillity'
          },
          en: {
            link: '/en/sustainability',
            title: 'Building a sustainable future for all',
            category: 'sustainabillity'
          }
        },
        {
          target: '_self',
          pc: require('@/static/image/main/pc/banner-6-1.jpg'),
          m: require('@/static/image/main/m/banner-6-1.jpg'),
          ko: {
            link: '/newsroom',
            title: '따끈한 새 소식',
            category: 'newsroom'
          },
          en: {
            link: '/en/newsroom',
            title: 'What\'s new',
            category: 'newsroom'
          }
        },
        {
          target: '_self',
          pc: require('@/static/image/service/font.jpg'),
          m: require('@/static/image/service/font.jpg'),
          video: require('@/static/video/service_font.mp4'),
          ko: {
            link: '/fonts',
            title: '배민 글꼴<br class="m"> 무료 배포',
            category: 'font'
          },
          en: {
            link: '/en/fonts',
            title: 'Download Baemin fonts for free',
            category: 'font'
          }
        },
        {
          target: '_self',
          pc: require('@/static/image/main/pc/banner-8.jpg'),
          m: require('@/static/image/main/m/banner-8.jpg'),
          ko: {
            link: '/service/order',
            title: '한그릇',
            category: 'service'
          },
          en: {
            link: '/en/service/order',
            title: 'Meal for one',
            category: 'service'
          }
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE'
    })
  },
  activated () {
     this.visualSlider.updateSlides()
     this.visualSlider.slideTo(1, 0, false)
  },
  mounted () {
    this.setVisualSwiper()
  },
  methods: {
    setVisualSwiper () {
      const options = {
        autoplay: {
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
          delay: 5000
        },
        loop: true,
        centeredSlides: true,
        slidesPerView: 1,
        // loopFillGroupWithBlank: true,
        pagination: {
          el: this.$refs.pagination,
          type: 'bullets',
          clickable: true,
          bulletActiveClass: 'active',
          bulletClass: 'swiper-pagination-bullet',
          bulletElement: 'button',
          modifierClass: ''
        },
        // scrollbar: {
        //   el: this.$refs.scrollbar,
        // },
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev
        },
        on: {
          afterInit (s) {
            s.el.style.setProperty('--swiper-pagination-length', s.pagination.bullets.length)
          },
          activeIndexChange (s) {
            s.el.style.setProperty('--swiper-pagination-index', s.realIndex)
          },
          snapIndexChange (s) {
            const _video = s.slides[s.activeIndex].querySelector('video')
            if (_video !== null && _video !== undefined) {
              _video.play()
            }
          }
       }
      }

      this.visualSlider = new Swiper(this.$refs.visualSwiper, options)
    },
  }
}
</script>
